import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import DemoJson from '../assets/json/20230831demos.json';
import TrustJson from '../assets/json/20230831scores.json';
import BestJson from '../assets/json/20230831bestfactorscores.json';
import BehaviorJson from '../assets/json/20230831behaviors.json';
import AttributeJson from '../assets/json/20230831attributes.json';
import TotalJson from '../assets/json/totals_model.json';


//Services
import { ErrorhandlerService } from './errorhandler.service';
//Environment
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CampaignService {
	demoObj: any | [];
	trustObj: any | [];
	attrObj: any | [];
	bestObj: any | [];
	behaviorObj: any | [];
	totalObj:any|[];
	current_page="aboutus";
	current_tab="discover";
	private apiUrl = environment.apiUrl; 

  constructor(private http: HttpClient,
	private errorhandlerService: ErrorhandlerService
			  ) {
  
	 this.totalObj=TotalJson;
	 this.trustObj=TrustJson;
	 this.bestObj=BestJson;
	 this.behaviorObj=BehaviorJson;
	 this.demoObj=DemoJson;
	 this.attrObj=AttributeJson;
	 //this.updateContent();
  }
	updateContent(){
		var arr=TotalJson;
		console.log('arr', arr);
		console.log('tota', this.totalObj);
		
	/*	this.pullScores().subscribe((response) => {
			this.trustObj=response;
	//		console.log('trust',typeof(this.trustObj));
		});
		this.pullDemos().subscribe((response) => {
			this.demoObj=response;
		//	console.log('demo',this.demoObj);
		});
		this.pullAttrs().subscribe((response) => {
			this.attrObj=response;
		//	console.log('demo',this.demoObj);
		});
		this.pullBest().subscribe((response) => {
			this.bestObj=response;
		//	console.log('demo',this.demoObj);
		});
		this.pullBehaviors().subscribe((response) => {
			this.behaviorObj=response;
			//this.processBehaviors(response);
			
			//console.log('beh',this.behaviorObj);
		});
		*/
	}
  
	toggleTab(newtab){
		this.current_tab=newtab;
	}
	
	processBehaviors(data){
		var arr=TotalJson[0];
		var x=0;
		data.forEach(function(obj){
			
				arr['responses']=Number(arr['responses'])+Number(obj['responses']);
arr['PurchResponse']=Number(arr['PurchResponse'])+Number(obj['PurchResponse']);
arr['PurchStrongResponse']=Number(arr['PurchStrongResponse'])+Number(obj['PurchStrongResponse']);
arr['AdvResponse']=Number(arr['AdvResponse'])+Number(obj['AdvResponse']);
arr['AdvStrongResponse']=Number(arr['AdvStrongResponse'])+Number(obj['AdvStrongResponse']);
arr['ServiceResponse']=Number(arr['ServiceResponse'])+Number(obj['ServiceResponse']);
arr['ServiceStrongResponse']=Number(arr['ServiceStrongResponse'])+Number(obj['ServiceStrongResponse']);
arr['PurchHumanityDisagree']=Number(arr['PurchHumanityDisagree'])+Number(obj['PurchHumanityDisagree']);
arr['PurchHumanityAgree']=Number(arr['PurchHumanityAgree'])+Number(obj['PurchHumanityAgree']);
arr['PurchTransparencyDisagree']=Number(arr['PurchTransparencyDisagree'])+Number(obj['PurchTransparencyDisagree']);
arr['PurchTransparencyAgree']=Number(arr['PurchTransparencyAgree'])+Number(obj['PurchTransparencyAgree']);
arr['PurchCapabilityDisagree']=Number(arr['PurchCapabilityDisagree'])+Number(obj['PurchCapabilityDisagree']);
arr['PurchCapabilityAgree']=Number(arr['PurchCapabilityAgree'])+Number(obj['PurchCapabilityAgree']);
arr['PurchReliabilityDisagree']=Number(arr['PurchReliabilityDisagree'])+Number(obj['PurchReliabilityDisagree']);
arr['PurchReliabilityAgree']=Number(arr['PurchReliabilityAgree'])+Number(obj['PurchReliabilityAgree']);
arr['PurchCompositeDisagree']=Number(arr['PurchCompositeDisagree'])+Number(obj['PurchCompositeDisagree']);
arr['PurchCompositeAgree']=Number(arr['PurchCompositeAgree'])+Number(obj['PurchCompositeAgree']);
arr['PurchStrongHumanityDisagree']=Number(arr['PurchStrongHumanityDisagree'])+Number(obj['PurchStrongHumanityDisagree']);
arr['PurchStrongHumanityAgree']=Number(arr['PurchStrongHumanityAgree'])+Number(obj['PurchStrongHumanityAgree']);
arr['PurchStrongTransparencyDisagree']=Number(arr['PurchStrongTransparencyDisagree'])+Number(obj['PurchStrongTransparencyDisagree']);
arr['PurchStrongTransparencyAgree']=Number(arr['PurchStrongTransparencyAgree'])+Number(obj['PurchStrongTransparencyAgree']);
arr['PurchStrongCapabilityDisagree']=Number(arr['PurchStrongCapabilityDisagree'])+Number(obj['PurchStrongCapabilityDisagree']);
arr['PurchStrongCapabilityAgree']=Number(arr['PurchStrongCapabilityAgree'])+Number(obj['PurchStrongCapabilityAgree']);
arr['PurchStrongReliabilityDisagree']=Number(arr['PurchStrongReliabilityDisagree'])+Number(obj['PurchStrongReliabilityDisagree']);
arr['PurchStrongReliabilityAgree']=Number(arr['PurchStrongReliabilityAgree'])+Number(obj['PurchStrongReliabilityAgree']);
arr['PurchStrongCompositeDisagree']=Number(arr['PurchStrongCompositeDisagree'])+Number(obj['PurchStrongCompositeDisagree']);
arr['PurchStrongCompositeAgree']=Number(arr['PurchStrongCompositeAgree'])+Number(obj['PurchStrongCompositeAgree']);
arr['AdvHumanityDisagree']=Number(arr['AdvHumanityDisagree'])+Number(obj['AdvHumanityDisagree']);
arr['AdvHumanityAgree']=Number(arr['AdvHumanityAgree'])+Number(obj['AdvHumanityAgree']);
arr['AdvTransparencyDisagree']=Number(arr['AdvTransparencyDisagree'])+Number(obj['AdvTransparencyDisagree']);
arr['AdvTransparencyAgree']=Number(arr['AdvTransparencyAgree'])+Number(obj['AdvTransparencyAgree']);
arr['AdvCapabilityDisagree']+=Number(obj['AdvCapabilityDisagree']);
arr['AdvCapabilityAgree']=Number(arr['AdvCapabilityAgree'])+Number(obj['AdvCapabilityAgree']);
arr['AdvReliabilityDisagree']=Number(arr['AdvReliabilityDisagree'])+Number(obj['AdvReliabilityDisagree']);
arr['AdvReliabilityAgree']=Number(arr['AdvReliabilityAgree'])+Number(obj['AdvReliabilityAgree']);
arr['AdvCompositeDisagree']=Number(arr['AdvCompositeDisagree'])+Number(obj['AdvCompositeDisagree']);
arr['AdvCompositeAgree']=Number(arr['AdvCompositeAgree'])+Number(obj['AdvCompositeAgree']);
arr['AdvStrongHumanityDisagree']=Number(arr['AdvStrongHumanityDisagree'])+Number(obj['AdvStrongHumanityDisagree']);
arr['AdvStrongHumanityAgree']=Number(arr['AdvStrongHumanityAgree'])+Number(obj['AdvStrongHumanityAgree']);
arr['AdvStrongTransparencyDisagree']=Number(arr['AdvStrongTransparencyDisagree'])+Number(obj['AdvStrongTransparencyDisagree']);
arr['AdvStrongTransparencyAgree']=Number(arr['AdvStrongTransparencyAgree'])+Number(obj['AdvStrongTransparencyAgree']);
arr['AdvStrongCapabilityDisagree']=Number(arr['AdvStrongCapabilityDisagree'])+Number(obj['AdvStrongCapabilityDisagree']);
arr['AdvStrongCapabilityAgree']=Number(arr['AdvStrongCapabilityAgree'])+Number(obj['AdvStrongCapabilityAgree']);
arr['AdvStrongReliabilityDisagree']=Number(arr['AdvStrongReliabilityDisagree'])+Number(obj['AdvStrongReliabilityDisagree']);
arr['AdvStrongReliabilityAgree']=Number(arr['AdvStrongReliabilityAgree'])+Number(obj['AdvStrongReliabilityAgree']);
arr['AdvStrongCompositeDisagree']=Number(arr['AdvStrongCompositeDisagree'])+Number(obj['AdvStrongCompositeDisagree']);
arr['AdvStrongCompositeAgree']=Number(arr['AdvStrongCompositeAgree'])+Number(obj['AdvStrongCompositeAgree']);
arr['ServiceHumanityDisagree']=Number(arr['ServiceHumanityDisagree'])+Number(obj['ServiceHumanityDisagree']);
arr['ServiceHumanityAgree']=Number(arr['ServiceHumanityAgree'])+Number(obj['ServiceHumanityAgree']);
arr['ServiceTransparencyDisagree']=Number(arr['ServiceTransparencyDisagree'])+Number(obj['ServiceTransparencyDisagree']);
arr['ServiceTransparencyAgree']=Number(arr['ServiceTransparencyAgree'])+Number(obj['ServiceTransparencyAgree']);
arr['ServiceCapabilityDisagree']=Number(arr['ServiceCapabilityDisagree'])+Number(obj['ServiceCapabilityDisagree']);
arr['ServiceCapabilityAgree']=Number(arr['ServiceCapabilityAgree'])+Number(obj['ServiceCapabilityAgree']);
arr['ServiceReliabilityDisagree']=Number(arr['ServiceReliabilityDisagree'])+Number(obj['ServiceReliabilityDisagree']);
arr['ServiceReliabilityAgree']=Number(arr['ServiceReliabilityAgree'])+Number(obj['ServiceReliabilityAgree']);
arr['ServiceCompositeDisagree']=Number(arr['ServiceCompositeDisagree'])+Number(obj['ServiceCompositeDisagree']);
arr['ServiceCompositeAgree']=Number(arr['ServiceCompositeAgree'])+Number(obj['ServiceCompositeAgree']);
arr['ServiceStrongHumanityDisagree']=Number(arr['ServiceStrongHumanityDisagree'])+Number(obj['ServiceStrongHumanityDisagree']);
arr['ServiceStrongHumanityAgree']=Number(arr['ServiceStrongHumanityAgree'])+Number(obj['ServiceStrongHumanityAgree']);
arr['ServiceStrongTransparencyDisagree']=Number(arr['ServiceStrongTransparencyDisagree'])+Number(obj['ServiceStrongTransparencyDisagree']);
arr['ServiceStrongTransparencyAgree']=Number(arr['ServiceStrongTransparencyAgree'])+Number(obj['ServiceStrongTransparencyAgree']);
arr['ServiceStrongCapabilityDisagree']=Number(arr['ServiceStrongCapabilityDisagree'])+Number(obj['ServiceStrongCapabilityDisagree']);
arr['ServiceStrongCapabilityAgree']=Number(arr['ServiceStrongCapabilityAgree'])+Number(obj['ServiceStrongCapabilityAgree']);
arr['ServiceStrongReliabilityDisagree']=Number(arr['ServiceStrongReliabilityDisagree'])+Number(obj['ServiceStrongReliabilityDisagree']);
arr['ServiceStrongReliabilityAgree']=Number(arr['ServiceStrongReliabilityAgree'])+Number(obj['ServiceStrongReliabilityAgree']);
arr['ServiceStrongCompositeDisagree']=Number(arr['ServiceStrongCompositeDisagree'])+Number(obj['ServiceStrongCompositeDisagree']);
arr['ServiceStrongCompositeAgree : 0']=Number(arr['ServiceStrongCompositeAgree : 0'])+Number(obj['ServiceStrongCompositeAgree : 0']);

		
		});
		//})
		console.log('arr2',arr);
		return arr;
	}
	getScores(){return this.trustObj;}
	getBest(){return this.bestObj;}
	getBehaviors(){return this.behaviorObj;}
	getDemos(){return this.demoObj;}
	getAttrs(){return this.attrObj;}
	
	/*pullScores():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'scores').pipe(
			catchError(
				this.errorhandlerService.handleError() 
			)
		);
	}*/
	pullBest():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'bestfactorscores').pipe(
			catchError(
				this.errorhandlerService.handleError() 
			)
		);
	}
	pullDemos():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'demos').pipe(
			catchError(
				this.errorhandlerService.handleError() 
			)
		);
	}
	pullAttrs():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'attributes').pipe(
			catchError(
				this.errorhandlerService.handleError() 
			)
		);
	}
	pullBehaviors():Observable<any>{
		return this.http.get<any[]>(this.apiUrl + 'behaviors').pipe(
			catchError(
				this.errorhandlerService.handleError() 
			)
		);
	}
	
}
